





















































import Vue from "vue";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig } from "@/components/root/modal";
import PolicyScriptCmp from "../PolicyScriptCmp.vue";
import {
  computed,
  onBeforeUnmount,
  onMounted,
  Ref,
  ref,
} from "@vue/composition-api";
import { UseDropdownItems } from "@/common/composition/dropdown-items";
import DropDownSimple from "@/components/dropdown/DropDownSimple.vue";
import { SharedState } from "@/common/state";
import * as api from "./data/api";
import { UseStatefulFn } from "@/common/composition/loading";
import { emptyFn } from "@/fp";
import { AppScript } from "@/views/playbooks/data/models";
import * as script_api from "@/views/playbooks/data/api";
import { InfoTypeHelper } from "@/common/models";
export default Vue.extend({
  components: {
    Modal,
    PolicyScriptCmp,
    DropDownSimple,
  },
  // label_id,label_name
  props: ["modalData"],
  setup(props) {
    const config: ModalConfig = {
      title: "",
      desc: "",
      blank: true,
      width: "94rem",
      height: "65rem",
      withTopRightCloseBtn: true,
    };

    const script: Ref<AppScript | null> = ref(null);

    const active_policy_percentage = ref(-1);
    const is_policy_active = computed(() => {
      if (selected_item.value && active_policy_percentage.value != -1) {
        return active_policy_percentage.value == +selected_item.value.id;
      }
      return false;
    });
    const [items, selected_item, set_selected_item] = UseDropdownItems(
      [2, 5, 10, 20].map((id) => ({ id: id.toString(), name: `Top ${id}%` }))
    );

    const [
      l0_items,
      selected_l0_item,
      set_selected_l0_item,
      ,
      add_l0_watcher,
    ] = UseDropdownItems<{ id: string; name: string }>(
      SharedState.l0InfoTypes.value
        .filter(
          ({ id }) =>
            id !== SharedState.default_label_id.value &&
            id !== InfoTypeHelper.REGULATED_ID()
        )
        .map(({ id, labelName }) => {
          return { id, name: labelName };
        })
    );

    const texts = computed(() => {
      const { label_name } = props.modalData as {
        label_id: string;
        label_name: string;
      };
      return {
        // @ts-ignore
        title: `Educate risky users with ${label_name} information`,
        desc: "this is the description text",
        details: "this is the details text",
        mitigation: "this is the mitigation text",
        threats: ["one", "two", "three", "four"],
      };
    });

    const [activate, is_during_activation] = UseStatefulFn(async () => {
      await api.toggle_l0_risky_user_active_status({
        activate: true,
        id: selected_l0_item.value!.id,
        selected_percentage: +selected_item.value!.id,
      });
      active_policy_percentage.value = +selected_item.value!.id;
    });

    const [deactivate, is_during_deactivation] = UseStatefulFn(async () => {
      await api.toggle_l0_risky_user_active_status({
        activate: false,
        id: selected_l0_item.value!.id,
        selected_percentage: +selected_item.value!.id,
      });
      active_policy_percentage.value = -1;
    });

    const [init, is_loading_data, is_initial_load] = UseStatefulFn<
      string,
      void,
      void
    >(async (label_id) => {
      const res = await api.get_risky_users_status_list();
      if (res.success) {
        const { is_active, detect_percentage } = res.value.find(
          (f) => f.id === label_id
        )!;
        active_policy_percentage.value = is_active ? detect_percentage : -1;
        if (detect_percentage && is_active) {
          set_selected_item(detect_percentage.toString());
        }
      }
    });

    const show_activate_btn_loader = computed(
      () => !is_initial_load.value && is_loading_data.value
    );

    const show_full_loader = computed(
      () => is_initial_load.value && is_loading_data.value
    );

    const subs = {
      l0: emptyFn(),
    };

    onMounted(async () => {
      const res = await script_api.get_full_script(
        "ed0d5c78-0012-40ed-af48-9a754d2e1dcf"
      );

      if (res.success) {
        script.value = res.value;
      }

      const { label_id } = props.modalData as {
        label_id: string;
        label_name: string;
      };
      set_selected_l0_item(label_id);
      await init(label_id);

      subs.l0 = add_l0_watcher(async (id) => {
        await init(id);
      });
    });

    onBeforeUnmount(() => Object.values(subs).forEach((unsub) => unsub()));

    return {
      config,
      texts,
      activate,
      script,
      is_policy_active,
      show_full_loader,
      is_during_activation,
      deactivate,
      is_initial_load,
      is_loading_data,
      show_activate_btn_loader,
      items,
      selected_item,
      set_selected_item,
      l0_items,
      selected_l0_item,
      set_selected_l0_item,
    };
  },
});
